<template>
    <div class="group_activity" ref="group_activity">
        <titleBar  :title="title" v-if="!isRunInWeChat"></titleBar>
        <img class="header" :src="groupData.advertisement.img" alt="">
        <div class="end_time">
            <span>距拼团结束剩余</span>
            <span>{{time[3]}}天{{time[0]}}小时{{time[1]}}分钟{{time[2]}}秒</span>
        </div>
        <div :class="['tabbar',isFixed && 'active']" ref="tabbar">
            <span @click="chooseCourseList(index)" v-for="(item, index) in groupData.courseInfo" :key="index" :class="[ currTab == index && 'active']">{{item.title}}</span>
        </div>
        <!-- <div class="swiper-pagination tabbar" slot="pagination"></div> -->
        <!-- <swiper :options="swiperOption">
          <swiper-slide  class="course" v-for="(info, index) in groupData.courseInfo" :key="index">
            <scroller 
            class="scroller"
            :on-refresh="refresh" 
            ref="my_scroller">
              <div ref='listItem' v-for="(item, index) in info.list" :key="index">
                  <img @click="jumpDetail(item.groupInfoId)"  :src="item.img" alt="">
              </div>            
            </scroller>
            <div ref='listItem' v-for="(item, index) in info.list" :key="index">
                  <img @click="jumpDetail(item.groupInfoId)"  :src="item.img" alt="">
              </div>  
          </swiper-slide>
        </swiper> -->
        <div :class="['course',isFixed && 'active']" ref="course">
            <div v-for="(item, index) in groupData.courseInfo[currTab].list" :key="index">
                <img @click="jumpDetail(item.groupInfoId)"  :src="item.img" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/titleBar.vue";
import { isRunInWeChat } from "../../utils/env";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import service from "./service/service";

export default {
  name: "group_activity",
  data() {
    return {
      groupData: {
        advertisement: {
          img:
            "https://appd.knowbox.cn/ss/activity/group-buy/activity/header.png", //头图
          groupInfoId: 22
        },
        endTime: Math.round(new Date("2019-10-08 00:00:00")/1000) -  Math.round(new Date()/1000), //剩余时间
        courseInfo: [
          {
            title: "学霸集结",
            list: [
              {
                groupInfoId: 19,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/1-1.png"
              },
              {
                groupInfoId: 21,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/1-2.png"
              },
              {
                groupInfoId: 17,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/1-3.png"
              },
              {
                groupInfoId: 18,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/1-4.png"
              },
              {
                groupInfoId: 15,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/1-5.png"
              }
            ]
          },
          {
            title: "知识乐园",
            list: [
              {
                groupInfoId: 14,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-1.png"
              },
              {
                groupInfoId: 23,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-2.png"
              },
              {
                groupInfoId: 16,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-3.png"
              },
              {
                groupInfoId: 20,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-4.png"
              },
              {
                groupInfoId: 22,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-5.png"
              }
              // {
              //   groupInfoId: 22,
              //   img:
              //     "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-6.png"
              // },
              // {
              //   groupInfoId: 22,
              //   img:
              //     "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-7.png"
              // },
              // {
              //   groupInfoId: 22,
              //   img:
              //     "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/2-8.png"
              // }
            ]
          },
          {
            title: "成长必修",
            list: [
              {
                groupInfoId: 13,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/3-1.png"
              },
              {
                groupInfoId: 12,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/3-2.png"
              },
              {
                groupInfoId: 10,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/3-3.png"
              },
              {
                groupInfoId: 11,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/3-4.png"
              },
              {
                groupInfoId: 9,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/3-5.png"
              },
              {
                groupInfoId: 8,
                img:
                  "https://appd.knowbox.cn/ss/images/activity/activity/parents-pintuan-activity/3-6.png"
              }
            ]
          }
        ]
      },
      isRunInWeChat: isRunInWeChat(),
      title: "拼团",
      time: [],
      currTab: 0,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            let text = "";
            switch (index) {
              case 0:
                text = "学霸集结";
                break;
              case 1:
                text = "知识乐园";
                break;
              case 2:
                text = "成长必修";
                break;
            }
            return '<span class="' + className + '">' + text + "</span>";
          }
        }
      },
      listTop: 0,
      isFixed: false,
    };
  },
  components: {
    titleBar,
    swiper,
    swiperSlide
  },
  watch: {
    listTop(newVal) {
      this.isVisualRange(newVal);
    }
  },
  created: function() {
    this.token = utils.getQueryString("token");
    this.source = utils.getQueryString("source");
    this.version = utils.getQueryString("version");
    this.pageChannel = utils.getQueryString("pageChannel");
    this.timeDown(this.groupData.endTime);
  },
  mounted: function() {
    console.log("window.location.href", window.location.href);
    window.addEventListener("scroll", this.scrollToTop);
    // console.log(this.groupData.courseInfo);
    // // todo: 三个列表；
    // for (const i in this.groupData.courseInfo[0].list) {
    //   console.log(i,this.groupData.courseInfo[0].list);
    //   this.groupData.courseInfo[0].list[i].isRecord = false;
    // }
    // let _this = this;
    // service.scroll(() => {
    //   _this.listTop = _this.$refs.my_scroller.getPosition().top;
    // });
  },
  methods: {
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
        this.isFixed = scrollTop + this.$refs.group_activity.offsetTop + this.$refs.tabbar.offsetHeight >= this.$refs.course.offsetTop ? true : false;
    },
    refresh() {},
    isVisualRange(newVal) {
      if (!this.$refs.listItem) return;
      for (let i = 0; i < this.$refs.listItem.length; i++) {
        if (
          newVal + document.documentElement.clientHeight >
          this.$refs.listItem[i].offsetTop
        ) {
          if (!this.groupData.courseInfo[i].isRecord) {
            this.record(this.groupData.courseInfo[i], 0);
            this.groupData.courseInfo[i].isRecord = true;
          }
        }
      }
    },
    record(info, event) {
      const { token, source, version } = this.$store.state;
      utils.sendLog({
        token: this.token,
        version: this.version,
        source: this.source,
        extensionJson: JSON.stringify({
          tuangou_event: event,
          tuangou_productId: info.groupInfoId
        })
      });
    },
    jumpDetail(groupInfoId) {
      utils.sendLog(
        {
          token: this.token,
          version: this.version,
          source: this.source,
          extensionJson: {
            tuangou_productId: groupInfoId,
            tuangou_event: 1,
            pageChannel: this.pageChannel
          }
        },
        "hzxx853"
      );
      // url必带token，source，version，pageChannel
      const url = encodeURIComponent(
        window.location.href.split("group_activity").join("app_detail") +
          "&groupInfoId=" +
          groupInfoId
      );
      window.location.href = "hybird://method/openNewWindow?url=" + url;
    },
    chooseCourseList(index) {
      console.log(index);
      this.currTab = index;
    },
    timeDown(totalSeconds) {
      var time = [];
      //天
      var day =
        Math.floor(totalSeconds / (60 * 60 * 24)) < 10
          ? "0" + Math.floor(totalSeconds / (60 * 60 * 24))
          : Math.floor(totalSeconds / (60 * 60 * 24));
      var moduloo = totalSeconds % (60 * 60 * 24);
      //小时数
      var hours =
        Math.floor(moduloo / (60 * 60)) < 10
          ? "0" + Math.floor(moduloo / (60 * 60))
          : Math.floor(moduloo / (60 * 60));
      var modulo = moduloo % (60 * 60);
      //分钟
      var minutes =
        Math.floor(modulo / 60) < 10
          ? "0" + Math.floor(modulo / 60)
          : Math.floor(modulo / 60);
      //秒
      var seconds = modulo % 60 < 10 ? "0" + modulo % 60 : modulo % 60;
      //输出到页面
      time.push(hours, minutes, seconds, day);
      this.time = time;
      //延迟一秒执行自己
      let timer = setTimeout(() => {
        if (totalSeconds == 0) {
          clearTimeout(timer);
          return;
        }
        this.timeDown(totalSeconds - 1);
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.group_activity {
  width: 100%;
  background: #fff;
  min-height: calc(100vh - 0.88rem);
  margin-top: 0.88rem;
  .header {
    width: 100%;
    display: block;
    // height: 4.8rem;
  }
  .end_time {
    width: 100%;
    height: 0.84rem;
    line-height: 0.84rem;
    background-color: #ff571d;
    font-family: PingFangSC-Medium;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
    span:nth-child(1) {
      margin-left: 0.2rem;
    }
    span:nth-child(2) {
      margin-right: 0.2rem;
      float: right;
    }
  }
  .tabbar {
    width: 100%;
    height: 0.76rem;
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 0.3rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #5f6162;
    border: 0.01rem solid #f0f0f0;
    justify-content: space-around;
    background: #fff;
    &.active {
      position: fixed;
      top: .88rem;
    }
    span {
      margin-top: 0.18rem;
      height: 0.46rem;
      &.active {
        color: #ff571d;
        border-bottom: 0.03rem solid #ff571d;
        font-size: 0.34rem;
        margin-top: 0.14rem;
        font-weight: bolder;
      }
    }
  }
  .course {
    &.active {
      margin-top: .76rem;
    }
    div {
      margin: 0 0.3rem;
      padding: 0.2rem 0 0.25rem 0;
      border-bottom: 0.01rem solid #f3f3f3;
      img {
        width: 100%;
      }
    }
  }
}
.swiper-container {
  top: 0.75rem;
  background: #fff;
}
</style>